import loadable from '@loadable/component';

export const AsyncLoanRejected = loadable(() => import('./LoanRejected'));
